import { EventElement } from "../EventItem/EventElement";
import { TableBox } from "@lk-gtcom/ecomlab-components";
import { useRef } from "react";
import { useState, useEffect } from "react";

const CalendarMonth = ({
    events_list,
    refHeaderTop,
    fetchEventData,
    setIsModal,
    setAddEvent,
    setReadOnly,
    setNewEvent,
    setEventInfo,
    selectedEvent,
    setSelectedEvent,
    setIsModalCard,
    selectView,
    startDate }) => {

    const days_of_week = [
        'Пн',
        'Вт',
        'Ср',
        'Чт',
        'Пт',
        'Сб',
        'Вс'
    ];

    // Массив названий месяцев
    const monthNames = [
        'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
        'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
    ];

    const startDateObj = startDate;
    const current_month = startDateObj.getMonth();
    const current_year = startDateObj.getFullYear();
    const dayNow = startDateObj.getDate();

    // Получаем сегодняшнюю дату
    const today = new Date();
    const todayDay = today.getDate();
    const todayMonth = today.getMonth();
    const todayYear = today.getFullYear();

    const [positionElement, setPositionElement] = useState(0)

    const refContainer = useRef()
    const refHeader = useRef()


    const handleScroll = () => {
        const container = refContainer.current
        const header = refHeader.current
        const height_header = refHeaderTop?.current?.getBoundingClientRect()?.height
        const top = container.getBoundingClientRect().top

        let height;
        if (header) {
            height = header.getBoundingClientRect().height
        }

        if (top - height_header < 0) {
            setPositionElement(height_header - top)
        } else {
            setPositionElement(0)
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const smoothLinks = () => {
        const elements = [...document.querySelectorAll('.row-week__header[id]')]; // Только элементы с id

        for (let element of elements) {
            const id = element.getAttribute('id');
            if (id && parseInt(id) === dayNow) {
                // Вариант 1: С учетом фиксированных заголовков
                const headerHeight = refHeaderTop?.current?.getBoundingClientRect()?.height || 0;
                const tableHeaderHeight = refHeader?.current?.getBoundingClientRect()?.height || 0;
                const totalHeaderHeight = headerHeight + tableHeaderHeight;

                const elementRect = element.getBoundingClientRect();
                const offsetPosition = elementRect.top + window.pageYOffset - totalHeaderHeight; // 30px дополнительный отступ

                // Используем requestAnimationFrame для плавности
                requestAnimationFrame(() => {
                    window.scrollTo({
                        top: Math.max(0, offsetPosition), // Не даем уйти в отрицательные значения
                        behavior: 'smooth'
                    });
                });

                // Выходим из цикла после нахождения нужного элемента
                break;
            }
        }
    };

    useEffect(() => {
        smoothLinks()
    }, []);

    // Функция для получения дней месяца с предыдущими и последующими днями
    const generateMonthGrid = () => {
        const year = current_year;
        const month = current_month;

        // Первый день текущего месяца
        const firstDayOfMonth = new Date(year, month, 1);
        // Последний день текущего месяца
        const lastDayOfMonth = new Date(year, month + 1, 0);

        // День недели первого дня месяца (0 - воскресенье, 1 - понедельник, etc.)
        const firstDayOfWeek = firstDayOfMonth.getDay();
        // День недели последнего дня месяца
        const lastDayOfWeek = lastDayOfMonth.getDay();

        // Количество дней в предыдущем месяце
        const daysInPrevMonth = new Date(year, month, 0).getDate();

        const days = [];

        // Добавляем дни предыдущего месяца
        const prevMonthDaysCount = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
        for (let i = prevMonthDaysCount; i > 0; i--) {
            const day = daysInPrevMonth - i + 1;
            days.push({
                day,
                month: month - 1,
                year: month === 0 ? year - 1 : year,
                date: new Date(month === 0 ? year - 1 : year, month - 1, day),
                week: new Date(month === 0 ? year - 1 : year, month - 1, day).getDay(),
                isOtherMonth: true
            });
        }

        // Добавляем дни текущего месяца
        const daysInMonth = lastDayOfMonth.getDate();
        for (let day = 1; day <= daysInMonth; day++) {
            days.push({
                day,
                month,
                year,
                date: new Date(year, month, day),
                week: new Date(year, month, day).getDay(),
                isOtherMonth: false
            });
        }

        // Добавляем дни следующего месяца
        const nextMonthDaysCount = lastDayOfWeek === 0 ? 0 : 7 - lastDayOfWeek;
        for (let day = 1; day <= nextMonthDaysCount; day++) {
            days.push({
                day,
                month: month + 1,
                year: month === 11 ? year + 1 : year,
                date: new Date(month === 11 ? year + 1 : year, month + 1, day),
                week: new Date(month === 11 ? year + 1 : year, month + 1, day).getDay(),
                isOtherMonth: true
            });
        }

        return days;
    };

    const monthDays = generateMonthGrid();
    const weeks = [];

    // Разбиваем дни по неделям (по 7 дней)
    for (let i = 0; i < monthDays.length; i += 7) {
        weeks.push(monthDays.slice(i, i + 7));
    }

    // Функция для получения событий на определенную дату
    const getEventsForDate = (day, month, year) => {
        const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const eventForDate = events_list.find(event => event.date === dateStr);
        return eventForDate ? eventForDate.events : [];
    };

    return (
        <div className='calendar-grid'>
            {selectView == 'Table' ?
                <TableBox
                    loading={null}
                    fetchedData={[]}
                    headers={[]}
                    paginator={true}
                /> :
                <table className='table-week' ref={refContainer}>
                    <thead ref={refHeader} style={{
                        transform: `translateY(${positionElement}px)`,
                        boxShadow: positionElement > 0 ? `0px 2px 8px 0px rgba(236, 234, 249, 0.60)` : ''
                    }}>
                        <tr>
                            <th className="calendar-grid__header_item calendar-grid__header_item_month"></th>
                            <th colSpan={9} className="calendar-grid__header_item calendar-grid__header_item_month">
                                <div className='date-box'>
                                    <p className='month_text'>
                                        {monthNames[current_month] ? monthNames[current_month] : monthNames[0]} {current_year}
                                    </p>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="calendar-grid__header_item calendar-grid__header_item_month"></th>
                            {days_of_week.map((dayName, index) => (
                                <th key={index} className='calendar-grid__header_item calendar-grid__header_item_month'>
                                    <div className='date-box'>
                                        <p className='month_text'>{dayName}</p>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {weeks?.map((week, weekIndex) => (
                            <tr key={weekIndex} className='row-week'>
                                <td className='time-box' >
                                    <div className="count-week">{`${weekIndex + 1}-ая неделя`}</div>
                                </td>

                                {week?.map((day, dayIndex) => {
                                    // Проверяем, является ли день сегодняшним
                                    const isToday = !day.isOtherMonth &&
                                        day.day === todayDay &&
                                        day.month === todayMonth &&
                                        day.year === todayYear;

                                    // Старая проверка для startDate
                                    const isTodayOld = !day.isOtherMonth && day.day === dayNow && day.month === current_month;

                                    const dayEvents = getEventsForDate(day.day, day.month, day.year);

                                    return (
                                        <td
                                            key={`${day.month}-${day.day}-${dayIndex}`}
                                            className='row-week__item row-week__item_month'
                                            data-date={day.date}
                                            data-day={day.day}

                                            onClick={(e) => {
                                                if (!e.target.closest('.event-item')) {
                                                    const selectDate = new Date(day.date);
                                                    selectDate.setHours(12, 0, 0);
                                                    setIsModalCard(false)
                                                    setIsModal(true)
                                                    setNewEvent(true)
                                                    setAddEvent(true)
                                                    setEventInfo({
                                                        dateFrom: selectDate,
                                                        dateTo: new Date(selectDate.getTime() + 3600000)
                                                    })
                                                    setReadOnly(false)
                                                }
                                            }}
                                            style={{
                                                verticalAlign: 'top',
                                                position: 'relative',
                                                opacity: day.isOtherMonth ? 0.4 : 1,
                                                background: isTodayOld ? 'rgb(235 245 255)' : '',
                                            }}
                                        >
                                            <div
                                                className="row-week__header"
                                                id={!day.isOtherMonth ? day.day : undefined}
                                                style={{ background: isToday ? '#3900B1' : '', }}
                                            >
                                                <span>{day.day + ' ' + (monthNames[day.month]?.slice(0, 3) || monthNames[0]?.slice(0, 3))}</span>
                                            </div>

                                            <div className="month-events-container">
                                                {!day?.isOtherMonth && dayEvents?.map((event, eventIndex) => {

                                                    const dateFrom = new Date(event.start_time);
                                                    const dateTo = new Date(event.end_time);

                                                    return (
                                                        <EventElement
                                                            key={`${day.month}-${day.day}-${eventIndex}`}
                                                            fetchEventData={() => fetchEventData(event.id)}
                                                            id={event.id || `${day.month}-${day.day}-${eventIndex}`}
                                                            title={event.title}
                                                            dateFrom={dateFrom}
                                                            dateTo={dateTo}
                                                            setReadOnly={setReadOnly}
                                                            style={{
                                                                position: 'static',
                                                                zIndex: 1,
                                                                marginBottom: '2px'
                                                            }}
                                                            selectedEvent={selectedEvent}
                                                            setSelectedEvent={setSelectedEvent}
                                                            setIsModalCard={setIsModalCard}
                                                        />
                                                    );
                                                }
                                                )}
                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </div>
    )
}

export default CalendarMonth;